var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17H15M3 14.6V12.1301C3 10.9814 3 10.4071 3.14805 9.87813C3.2792 9.4096 3.49473 8.96892 3.78405 8.57774C4.11067 8.13614 4.56404 7.78352 5.47078 7.07828L8.07078 5.05606C9.47608 3.96304 10.1787 3.41654 10.9546 3.20646C11.6392 3.0211 12.3608 3.0211 13.0454 3.20646C13.8213 3.41654 14.5239 3.96305 15.9292 5.05606L18.5292 7.07828C19.436 7.78352 19.8893 8.13614 20.2159 8.57774C20.5053 8.96892 20.7208 9.4096 20.8519 9.87813C21 10.4071 21 10.9814 21 12.1301V14.6C21 16.8402 21 17.9603 20.564 18.816C20.1805 19.5686 19.5686 20.1805 18.816 20.564C17.9603 21 16.8402 21 14.6 21H9.4C7.15979 21 6.03969 21 5.18404 20.564C4.43139 20.1805 3.81947 19.5686 3.43597 18.816C3 17.9603 3 16.8402 3 14.6Z",
    stroke: "#98A4A8",
    strokeWidth: 2,
    fill: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.cf6b3c613167135e3a54158e35538b9c.svg";
export { ForwardRef as ReactComponent };